import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';

interface IReadyApartmentsProps {
  readyApartments: boolean;
  onChange: (event: React.SyntheticEvent, value: boolean) => void;
}

export function ReadyApartments({ readyApartments, onChange }: IReadyApartmentsProps) {
  return <Checkbox label="Готовые квартиры" checked={readyApartments} onChange={onChange} />;
}
